module.exports = __webpack_public_path__ + "img/for-sale-post.faa37ee9.png";